module.exports = __webpack_public_path__ + "static/img/logo_pic.a9531d4.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/logo_pic.png
// module id = C9Kw
// module chunks = 1